import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-init-loader',
  templateUrl: './app-init-loader.component.html',
  styleUrls: ['./app-init-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppInitLoaderComponent {}
